import React from "react";

const FullPageSpinner = ({ isVisible = false }) => {
  if (!isVisible) return null;

  return (
    <>
      <style>
        {`
          .spinner-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            z-index: 9999;
            background-color: rgba(0, 0, 0, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .spinner {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            border: 5px solid rgba(255, 255, 255, 0.3);
            border-top-color: #ffffff;
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      <div className="spinner-overlay">
        <div className="spinner"></div>
      </div>
    </>
  );
};

export default FullPageSpinner;
